import React from 'react';
import PropTypes from 'prop-types';
import { ChannelJoinButton, ChannelName, ChannelProfileImage } from '../ChannelProfileInfo';
import { ImageCreateChannel } from '../../rootAccess';
import logger from '../../../Helpers/logger';

function ExploreChannelItem({ item, searchText }) {
    logger.debug('explore channel list', item);
    const { name, channelId } = item;
    logger.debug('channel name', name);
    return (
        <>
            <div className="channelListBlock">
                <div className="channelListBox">
                    <ul>
                        <li>
                            <div className="channelList">
                                <figure>
                                    <ChannelProfileImage
                                        alt={name}
                                        channelId={channelId}
                                        defaultImg={ImageCreateChannel}
                                    />
                                </figure>
                                <div className="channelDetails">
                                    <ChannelName
                                        channelId={channelId}
                                        channelName={name}
                                        className="channel-name"
                                        searchText={searchText}
                                        channelStatus="explore"
                                    />
                                    <p>2.2L followers</p>
                                </div>
                                <ChannelJoinButton channelId={channelId} className="join-button" />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}

export default ExploreChannelItem;

ExploreChannelItem.propTypes = {
    item: PropTypes.object,
    searchText: PropTypes.string,
};
